import { ArrowDown, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ContactButton, Wordmark } from './BrandElements';
import { DigestMotif } from './DigestMotif';
import { SectionNode } from './SectionNode';
import { ArchitectureDiagram } from './ArchitectureDiagram';

export const HERO_HEADING = 'Systems that govern themselves as they operate.';

export const Hero = () => (
  <>
    <section className="hero container chain-pad chain-line" id="introduction" aria-labelledby="hero-title" data-testid="hero-section">
      <div className="hero-copy">
        <div className="hero-eyebrow" data-testid="hero-eyebrow"><SectionNode id="hero" heading={HERO_HEADING} /></div>
        <div className="hero-wordmark" data-testid="hero-wordmark-lockup"><Wordmark id="hero" size="hero" /></div>
        <h1 id="hero-title" data-testid="hero-title">Systems that govern<br className="desktop-break" /> themselves <span className="headline-last">as they operate.</span></h1>
        <div className="hero-intro">
          <p className="hero-description" data-testid="hero-description">3tched is building a schema-driven operating environment where identity, authority, policy, state, and evidence stay connected.</p>
          <p className="hero-description" data-testid="hero-description-2">Instead of reconstructing proof after something happens, 3tched is designed to produce evidence as a consequence of the system operating correctly.</p>
        </div>
        <div className="hero-actions"><ContactButton id="hero-contact-button" label="Talk with us" /><Link to="/#how-it-works" className="text-link explore-link" data-testid="explore-architecture-link">See how it works <ArrowDown size={14} aria-hidden="true" /></Link></div>
        <p className="pronunciation mono" data-testid="brand-pronunciation">3tched <span>/</span> pronounced “etched”</p>
      </div>
      <figure className="hero-figure" data-testid="hero-architecture-figure">
        <div className="diagram-heading mono"><span data-testid="diagram-heading">ARCHITECTURE DIAGRAMS</span><Plus size={13} aria-hidden="true" /></div>
        <div className="architecture-links">
          <ArchitectureDiagram variant="regular" />
          <ArchitectureDiagram variant="embodied" />
        </div>
        <DigestMotif id="hero" showCaption={false} />
        <figcaption className="diagram-caption mono" data-testid="diagram-caption"><span>One model. Linked state history.</span><span>Illustrative architecture & digests · not live telemetry</span></figcaption>
      </figure>
    </section>
    <div className="schema-bridge container chain-pad chain-line" data-testid="schema-bridge">
      <p data-testid="schema-bridge-title">One schema.<br /><span>Every layer.</span></p>
      <div className="bridge-layers mono" data-testid="connected-layers">{['Identity', 'Authority', 'Policy', 'State', 'Evidence'].map(layer => <span key={layer} className={layer === 'Evidence' ? 'bridge-evidence' : ''} data-testid={`bridge-layer-${layer.toLowerCase()}`}><span className="bridge-node" />{layer}</span>)}</div>
    </div>
  </>
);
